import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content:space-between;
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 9px;
  background-color: rgba(0,0,0,1);
    box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  overflow:hidden;
  position: relative;

  @media (max-width: 768px) {
    height:350px;

  }

`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  height: auto;
  margin-left:0px;
`;

const Right = styled.div`
  display: flex;
  height: auto;

  justify-content: center;
    width: 50%;
  z-index:0;
    @media (max-width: 768px) {
    margin-right:40px;
    margin-top:15px;
    justify-content:flex-start;
  }

`;

const Bg = styled.img`
 
  position: absolute;
  height:100%;
  justify-content: space-around;

  opacity:90%;

    @media (max-width: 768px) {
   margin-right:0px;
  }
    
`;
const Coverbg = styled.img`
  position: absolute;
  max-height: 105%;
  min-width: 105%;
  object-fit: cover;
  align-self:center;
  margin-left:-5px;
  opacity:70%;   
  border: none;
`;


const Inner01 = styled.div`
  display: flex;
  flex-start;
  flex-direction:column;
  width: 50%;
  height: auto;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;

`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:left;

`;

const Subtag = styled.span`
  font-size: 0.9rem;
  color: #8a7700;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:left;
  margin-left:10px;

`;

const Row = styled.div`
  display: flex;
  flex-direction:row;
  flex-wrap:wrap;
`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.4em;
  letter-spacing: .6px;

  
`;
const Paragraph = styled.p`
  font-family:roboto;
  font-size: 0.9rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  z-index:5;

  
`;

const ReusableInfoCard = (props) => {

  return(

  <Container>              
    <Left>
    <Inner01>
        <Row>
           <Tag>{props.tag}</Tag>
           <Subtag>{props.subtag}</Subtag>
        </Row>   
        <Description>{props.description}</Description>
        <Paragraph>{props.paragraph}</Paragraph> 
      
     
    </Inner01>
    </Left>
    <Right>
    <Bg src= {props.background}/>
    </Right>
   <Coverbg src= {props.coverbackground}/>
  </Container>

 );
}
export default ReusableInfoCard;
